import { Text } from 'grommet';
import React, { useState } from 'react';
import {
    faLinkSimple as IconLink
} from '@fortawesome/pro-light-svg-icons';
import FontAwesomeIcon from './FontAwesomeIcon';
import Button from './Button';

// copy link button that gets the job done without showing the link to copy
const CopyLinkButton = ({
    link,
    copyLabel
}) => {
    const [isClicked, setIsClicked] = useState(false);

    // Copying a link should not also trigger whatever is underneath it - e.g. a
    // table row's onRowClicked when this sits in a row, as it does on the
    // deposits list. Stop propagation here rather than at every call site.
    const copyLink = async (e) => {
        e && e.stopPropagation();
        await navigator.clipboard.writeText(link);
        setIsClicked(true);
        setTimeout(() => {
            setIsClicked(false); // reset tooltip text
        }, 1000);
    };

    return (
        <Button
            event={{section: 'copy_link_button', element: 'copy', description: link}}
            tip={isClicked ? "Copied!" : "Copy link"}
            hoverIndicator
            onClick={copyLink}
            secondary
            label={copyLabel ? 
                (<Text textAlign="center">{copyLabel}</Text>) : 
                (
                    <FontAwesomeIcon SelectedIcon={IconLink} size="xsmall" />
                )
            } />
    );
}

export default CopyLinkButton;